import { translations as enTranslations } from '../translations/en';
import { translations as arTranslations } from '../translations/ar';

export const getTranslations = (language) => {
  return language === 'ar' ? arTranslations : enTranslations;
};

